import { useTranslation } from 'react-i18next';
import { useContent } from '../contexts/ContentContext';

interface KPIItem {
  title: string;
  description: string;
}

export const KPI = () => {
  const { t } = useTranslation();
  const { getValue } = useContent();

  const baseItems = t('kpi.items', { returnObjects: true }) as KPIItem[];
  const items = baseItems.map((item, idx) => ({
    title: getValue(`kpi.items.${idx}.title`, item.title),
    description: getValue(`kpi.items.${idx}.description`, item.description),
  }));

  const eyebrow = getValue('kpi.eyebrow', t('kpi.eyebrow'));
  const title = getValue('kpi.title', t('kpi.title'));
  const subtitle = getValue('kpi.subtitle', t('kpi.subtitle'));

  return (
    <section id="kpi" className="py-14 animate-section bg-[linear-gradient(135deg,rgba(79,70,229,0.16)_0%,rgba(124,58,237,0.14)_50%,rgba(79,70,229,0.28)_100%)] dark:bg-[rgba(15,18,48,0.85)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <p className="uppercase tracking-widest text-xs font-semibold text-regai-accent mb-2">
            {eyebrow}
          </p>
          <h2 className="text-3xl md:text-4xl font-extrabold leading-tight">{title}</h2>
          <p className="mt-3 text-regai-muted text-lg">{subtitle}</p>
        </div>

        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6 card-group">
          {items.map((item, idx) => (
            <div
              key={idx}
              className="rounded-2xl border border-white/15 bg-regai-surface/90 p-6 backdrop-blur-sm"
            >
              <h3 className="font-bold">{item.title}</h3>
              <p className="text-regai-muted mt-2">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
